import React from 'react';
import { Node as ContentfulNode } from '@contentful/rich-text-types';
import { DocumentWithEmbeddedEntries } from 'libs/contentful/types';
import Link from 'components/shared/Link/Link';

const renderAssetHyperlink = (
  node: ContentfulNode,
  children: React.ReactNode,
  content: DocumentWithEmbeddedEntries,
) => {
  const hyperlinkAssets = content?.links?.assets?.hyperlink || [];
  const asset = hyperlinkAssets.find(i => i.sys.id === node.data.target.sys.id);

  if (!asset?.url) return null;

  return (
    <Link href={asset.url} className="inline underline" data-testid="asset-hyperlink">
      {children}
    </Link>
  );
};

export default renderAssetHyperlink;
